var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalCosmote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15622_161635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1938 41.4025H44.1872C43.7817 41.4025 43.7422 41.6023 43.7422 41.7621V42.5114H45.107V46.4974H46.2741V42.5114H47.6488V41.7621C47.6488 41.6023 47.6092 41.4025 47.1938 41.4025Z",
    fill: "#3B61A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9264 44.9989C21.1736 45.2486 21.5297 45.6083 21.5791 45.6682C21.233 46.0478 20.5703 46.5973 19.6407 46.5973C18.2264 46.5973 17 45.4884 17 43.9499C17 42.4215 18.2066 41.2926 19.6407 41.2926C20.5901 41.2926 21.2132 41.8021 21.5692 42.1617C21.5297 42.2017 21.1736 42.5613 20.9363 42.8211C20.7385 43.0309 20.5011 42.881 20.3824 42.8011C20.2044 42.6812 19.9769 42.5613 19.6407 42.5613C18.9088 42.5613 18.2956 43.1807 18.2956 43.9499C18.2956 44.7292 18.889 45.3286 19.6407 45.3286C19.9176 45.3286 20.1747 45.2387 20.3824 45.0788C20.5308 44.9689 20.7582 44.8091 20.9264 44.9989Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 43.9499C21.7461 42.4814 22.9131 41.2926 24.367 41.2926C25.8208 41.2926 26.9977 42.4814 26.9977 43.9499C26.9977 45.4185 25.8208 46.5973 24.3769 46.5973C22.923 46.5973 21.7461 45.4185 21.7461 43.9499ZM23.0219 43.9499C23.0219 44.7292 23.6054 45.3386 24.3769 45.3386C25.1384 45.3386 25.712 44.7292 25.712 43.9499C25.712 43.1707 25.1285 42.5513 24.367 42.5513C23.5955 42.5513 23.0219 43.1707 23.0219 43.9499Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3711 43.9499C38.3711 42.4814 39.548 41.2926 40.992 41.2926C42.4359 41.2926 43.6227 42.4814 43.6227 43.9499C43.6227 45.4185 42.4458 46.5973 41.0019 46.5973C39.548 46.5973 38.3711 45.4185 38.3711 43.9499ZM39.6469 43.9499C39.6469 44.7292 40.2304 45.3386 41.0019 45.3386C41.7634 45.3386 42.3469 44.7292 42.3469 43.9499C42.3469 43.1707 41.7535 42.5513 40.992 42.5513C40.2205 42.5513 39.6469 43.1707 39.6469 43.9499Z",
    fill: "url(#paint0_linear_15622_161635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1665 41.4025H37.1456L37.9269 46.4974H36.6214L36.2357 43.5703L34.8115 46.4974L33.417 43.5503L33.0709 46.4974H31.7852L32.4379 42.1217C32.4874 41.7921 32.5368 41.4025 32.972 41.4025H33.7928L34.8313 43.85L35.6324 41.9219C35.7115 41.7122 35.7907 41.4025 36.1665 41.4025Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2527 45.4485C31.5889 44.3496 30.679 43.7702 30.234 43.5204C29.7889 43.2607 29.3439 43.0709 29.2252 43.0209C29.1164 42.971 28.8296 42.8511 28.9483 42.5913C29.1362 42.1618 29.9274 42.6013 30.2933 42.7812C30.6593 42.961 30.7384 42.7712 30.7681 42.7112L31.1735 41.942C31.1735 41.942 30.2241 41.3426 29.3834 41.2926C28.1175 41.2127 27.4944 42.1218 27.5241 42.7812C27.5241 43.5504 28.2955 43.98 29.0571 44.3396C29.8186 44.6893 29.9274 44.8891 29.9274 45.0489C29.9274 45.1987 29.8384 45.4785 29.3637 45.4785C28.8889 45.4785 28.4241 45.0489 28.2659 44.929C28.1076 44.7991 27.9692 44.8591 27.8604 44.9989C27.7516 45.1388 27.3164 45.6783 27.3164 45.6783C27.712 46.0379 28.3944 46.6073 29.5219 46.6073C30.412 46.6073 31.0153 46.1878 31.2527 45.4485Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4297 46.5973C51.3693 46.5873 51.9231 46.1677 52.2099 45.868C52.2495 45.8281 52.0319 45.2786 51.7847 45.0189C51.5869 44.8091 51.3495 44.9589 51.2407 45.0289C51.033 45.1587 50.8451 45.3186 50.4099 45.3286C49.8858 45.3386 49.4308 44.9889 49.2132 44.5394H50.677V43.3506H49.2132C49.4308 42.891 49.8957 42.5613 50.4198 42.5613C50.7462 42.5613 50.9935 42.6812 51.1715 42.8011C51.2803 42.871 51.5275 43.0209 51.7154 42.8111C51.9627 42.5514 52.1803 41.9919 52.1407 41.952C51.7847 41.6423 51.3495 41.3126 50.4297 41.2926C48.9957 41.2527 47.7891 42.4315 47.7891 43.95C47.7891 45.4684 49.0154 46.5973 50.4297 46.5973Z",
    fill: "#3B61A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5592 42.2019C56.5592 42.2019 56.3911 37.067 51.0208 36.0081C45.6504 34.9491 57.2515 33.9102 57.2515 33.9102H62.068V43.0011H56.5592V42.2019Z",
    fill: "#E20074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5696 36.0083C68.1201 36.0083 70.9982 38.9154 70.9982 42.5018V51.9923H56.5586V36.0083H64.5696Z",
    fill: "#E20074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3745 48.2657V47.6563H61.78C62.4921 47.6563 62.8184 47.2368 62.8184 46.6074V40.2737H62.6998C61.3646 40.2737 60.5239 41.1628 60.5239 42.4715V42.5914H60.0195V39.6743H67.1503V42.5914H66.6459V42.4715C66.6459 41.1628 65.8052 40.2737 64.4701 40.2737H64.3514V46.6074C64.3514 47.2368 64.6778 47.6563 65.3899 47.6563H65.7954V48.2657H61.3745ZM67.1503 43.6204V45.3387H65.4591V43.6204H67.1503ZM61.7107 43.6204V45.3387H60.0195V43.6204H61.7107Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15622_161635",
    x1: 38.8443,
    y1: 45.4685,
    x2: 43.1737,
    y2: 42.4676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#509E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4A8D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3C659D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3B61A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B61A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15622_161635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 16,
    fill: "white",
    transform: "translate(17 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalCosmote);
export default __webpack_public_path__ + "static/media/logoModalCosmote.1d60c4806cb632c09230ef962fb17d6d.svg";
export { ForwardRef as ReactComponent };